import { ReactNode } from 'react';

export enum Orientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export type Option = {
  /* Descriptive text to display below the label */
  description?: string | ReactNode;
  /* Unique identifier for the option */
  id: string;
  /* Whether the option is disabled */
  isDisabled?: boolean;
  /** Whether the tooltip is enabled (i.e., appears on hover). */
  isTooltipEnabled?: boolean;
  /* Human-readable name of option. Can be function component. */
  label: string | ReactNode;
  /** Content to display in tooltip. */
  tooltipContent?: string | ReactNode;
  /* Value of the option; must be unique */
  value: string;
};

export type Props = {
  /* Label for the radio group */
  label?: string;
  /* Unique identifier for form field, passed down to all options */
  name: string;
  /* Callback to trigger on selection of an option. Receives the selected option's value */
  onSelect?: (value: any) => void;
  /* Available options */
  options: Option[];
  /* Currently selected value, to be passed by controlling parent */
  value: string | undefined;
  /* Whether the radio group is disabled entirely */
  isReadOnly?: boolean;
  /* Orientation of radio group */
  orientation?: Orientation;
  /* Boolean to determine if there is a border around the radio group */
  isBordered?: boolean;
  /* Alignment of radio boxes */
  radioAlignment?: 'flex-start' | 'center';
  /* Whether radio button is on the right side or left */
  alignRight?: boolean;
  /* Whether radio buttons are overlapping with label section */
  isOverlapped?: boolean;
};
